module.exports = __webpack_public_path__ + "img/search.34641c71.png";